import React, {useEffect} from 'react';
import Navbar from '../components/common/Navbar';
import { useLocation } from 'react-router-dom';
import Footer from '../components/common/Footer';
import AboutSection from '../components/Home/AboutSection';
import FaqSection from '../components/Home/FaqSection';
import ContactSection from '../components/Home/ContactSection';
import './HomePage.css';
import CarouselSection from '../components/Home/CarouselSection';
import SecondSection from '../components/Home/SecondSection';


const HomePage = () => {
  const location = useLocation();

  
useEffect(() => {
  if (location.hash) {
    const el = document.querySelector(location.hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}, [location]);

  return (
    <>
      <Navbar />
      <CarouselSection />
        
      <SecondSection />

      <div id="faq" style={{ paddingTop: '100px', marginTop: '-100px' }}>
      <FaqSection />
      </div>

      <div id="about" style={{ paddingTop: '100px', marginTop: '-100px' }}>
      <AboutSection />
      </div>
      
      <ContactSection />
           

      <Footer />
    </>
  );
};

export default HomePage;
